//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    ver,
    system
} from '../../../api';
import MHeader from '../../Header/Header.vue';
export default {
    data() {
        return {
            ver: "",
            system: ""
        }
    },
    components: {
        MHeader
    },
    created() {
        this.ver = ver;
        this.system = system;
    }
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/about/about.vue